import app from './app';

const captures = {
  compositorUrl(captureId: string) {
    return app.url + '/compositor/' + captureId;
  },
  traceDir: 'traces',
};
export default captures;
